import {API} from "../../Services";

async function StoreOnlineSendInfo(merchantId,page){
    let token =  localStorage.getItem('token');
    return API.get(`/orders/shipping_time_interval?merchant__uid=${merchantId}&page=${page}`,{headers: { 'Authorization':  `Bearer ${token}`}});
}

async function StoreOnlineSetSendInfo(uid,description=""){
    let token =  localStorage.getItem('token');
    console.log("OnStore : ",uid)
    return API.put(`/shop/cart/`,{
        shipping_time_interval:uid,
        description:description
    },{headers: { 'Authorization':  `Bearer ${token}`}});
}




export {StoreOnlineSendInfo,StoreOnlineSetSendInfo}
